import React from 'react'
import { translate } from 'react-i18next'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

const ModuleOffline = (props) => {
  const { translate } = props

  return (
    <div className='container-fluid header-offset error-hero'>
      <div className='error-info align-center color-neutral'>
        <h3 className='heading-3'>
          {translate('moduleOffline.sorry')}
          <span className='color-primary'>
            {' '}
            #{translate('moduleOffline.realhouse')}{' '}
          </span>
          {translate('moduleOffline.it_is_not_always_perfect')}
        </h3>

        <p>
          {translate(
            'moduleOffline.we_are_in_trouble_and_our_team_is_already_working_to_normalize_it'
          )}
        </p>
        {translate('moduleOffline.please_try_your_last_operation_again')}
      </div>
    </div>
  )
}

ModuleOffline.propTypes = {
  translate: PropTypes.func.isRequired,
}

const ComponentTranslated = translate(null, {
  wait: true,
  translateFuncName: 'translate',
})(ModuleOffline)

export default connect()(ComponentTranslated)

export { ModuleOffline }
